﻿import { BaseKb3dModel } from '../decorators/kb3d-decorator';
import { instanceOfAny } from '../decorators/model-utils';
import { ILightNode } from '../kb3d-models';
import { Kb3dObject } from '../kb3d-object';
import { SpaceNode } from '../meshes';
import { KbColor } from '../primitives/kb-color';
import { Token } from '../token';

@BaseKb3dModel({
    token: Token.LightNode,
})
export abstract class LightNode extends SpaceNode implements ILightNode {
    constructor() {
        super();
    }
    public visible: boolean;
    public intensity: number;
    public color: KbColor;

    getSpaceChildren() {
        return [];
    }
}

export function isLightNode(node: Kb3dObject): node is LightNode {
    return instanceOfAny<LightNode>(node, ...Token.LightTokens);
}
